import types from '../type';
import { getQueryField } from './url-params';
import axios from 'axios';
import uuidv4 from 'uuid/v4';
import { GET_SCRIPT_CONTENT } from '../regexp';
import * as loadRemote from './load-remote';

const isMobile =
    /iphone|ipad|ipod|android|windows phone/i.test(navigator.userAgent) ||
    ((navigator.platform || '').toLowerCase() == 'macintel' &&
        navigator.maxTouchPoints > 1) ||
    getQueryField('isMobile') === '1';
const isMobileReal = () => {
    return (
        /iphone|ipad|ipod|android|windows phone/i.test(navigator.userAgent) ||
        ((navigator.platform || '').toLowerCase() == 'macintel' &&
            navigator.maxTouchPoints > 1) ||
        getQueryField('isMobile') === '1'
    );
};

const isNodePuppeteer = getQueryField('node-ssr-puppeteer') === '1';

const isReallyUser =
    !/Chrome-Lighthouse|GTmetrix|Lighthouse/i.test(navigator.userAgent) &&
    !isNodePuppeteer;

const isIos =
    /iphone|ipad|ipod/i.test(navigator.userAgent) ||
    ((navigator.platform || '').toLowerCase() == 'macintel' &&
        navigator.maxTouchPoints > 1);
const isIphone = /iphone/i.test(navigator.userAgent);
const inApp = /chime/i.test(navigator.userAgent);

const prefixMethods = (function () {
    const methods = {},
        prefix = ['', 'webkit', 'moz', 'ms', 'o'];

    function getMethod(elem, method) {
        for (let i = 0, len = prefix.length; i < len; i++) {
            const md = elem[prefix[i] + method];
            if (!types.isNull(md)) {
                return prefix[i] + method;
            }
            if (i === 0) {
                method = method.charAt(0).toUpperCase() + method.slice(1);
            }
        }
        return false;
    }

    return {
        run(elem, method) {
            method = method.charAt(0).toLowerCase() + method.slice(1);
            let md = methods[method];
            if (types.isNull(md)) {
                md = methods[method] = getMethod(elem, method);
            }
            if (md !== false) {
                return types.isFunction(elem[md]) ? elem[md]() : elem[md];
            }
        }
    };
})();
const isUndef = obj => obj === null || obj === undefined;
function generateUploadOption(type, uuid = uuidv4()) {
    let business = 'cmsbuild',
        date = new Date();
    return {
        business,
        path: `/image/fs/${business}/${date.getFullYear()}${
            date.getMonth() + 1
        }${date.getDate()}/${date.getHours()}/original_${uuid}.${type}`
    };
}
/**
 *
 * @param {*} file {id,file,ext,filename}
 * @returns
 */
function upload(file) {
    return new Promise((resolve, reject) => {
        let ext = file.ext;
        if (!ext) {
            const r = (file.filename || '').match(/[^\.]+\.(.+)$/);
            if (r) {
                ext = r[1];
            } else {
                console.error('none ext');
            }
        }
        const { path, business } = generateUploadOption(ext, file.id);
        axios
            .get(
                '/api-site/aws/token/presignurl',
                {
                    params: {
                        business,
                        imageType: ext,
                        path
                    }
                },
                { timeout: 60000 }
            )
            .then(rt => {
                axios({
                    url: rt.data.url,
                    method: 'put',
                    timeout: 60000,
                    data: file.file,
                    headers: { 'Content-Type': 'image/' + ext }
                })
                    .then(() => {
                        resolve(`https://cdn.chime.me${path}`);
                        // resolve(['https://cdn.chime.me' + path, rt.data.url]);
                    })
                    .catch(e => {
                        console.log(e);
                        reject('Upload error.');
                    });
            });
    });
}
export default {
    upload,
    isMobile,
    isMobileReal,
    isReallyUser,
    isNodePuppeteer,
    isIos,
    isIphone,
    inApp,
    ...loadRemote,
    inNode() {
        return (
            typeof XMLHttpRequest === 'undefined' &&
            typeof window === 'undefined' &&
            typeof process !== 'undefined' &&
            !process.browser
        );
    },
    ...types,
    getMutationType(storeName) {
        return mutationType => `${storeName}/${mutationType}`;
    },
    commit(store) {
        return (mutationType, payload) => {
            store.commit(mutationType, payload);
        };
    },
    dispatch(store) {
        return async (actionType, payload) => {
            await store.dispatch(actionType, payload);
        };
    },
    initAsyncData({ store, blockStoreName }) {
        const mutationType = this.getMutationType(blockStoreName);
        const commit = this.commit(store);
        const dispatch = this.dispatch(store);
        const getters = this.getter(store, blockStoreName);
        const blockState = store.state[blockStoreName];
        const globalData = store.state.page.page;
        const renderStatus = store.state.common.renderStatus;
        return {
            mutationType,
            commit,
            dispatch,
            getters,
            blockState,
            globalData,
            renderStatus
        };
    },
    getter(store, storeName) {
        return getterKey => store.getters[`${storeName}/${getterKey}`];
    },
    isFullScreen() {
        let isFullScreen = prefixMethods.run(document, 'isFullScreen');
        if (types.isNull(isFullScreen)) {
            isFullScreen = prefixMethods.run(document, 'fullScreen');
        }
        return !!isFullScreen;
    },
    isIE() {
        const userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
        const isIE =
            userAgent.indexOf('compatible') > -1 &&
            userAgent.indexOf('MSIE') > -1; //判断是否IE<11浏览器
        const isEdge = userAgent.indexOf('Edge') > -1 && !isIE; //判断是否IE的Edge浏览器
        const isIE11 =
            userAgent.indexOf('Trident') > -1 &&
            userAgent.indexOf('rv:11.0') > -1; //判断是否是IE11浏览器
        return isIE || isEdge || isIE11;
    },
    /**
     * 返回对应cname的cookie值
     */
    getCookie(cname) {
        const name = cname + '=';
        try {
            const ca = document.cookie.split(';');
            for (let i = 0, len = ca.length; i < len; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') c = c.substring(1);
                if (c.indexOf(name) === 0)
                    return c.substring(name.length, c.length);
            }
        } catch (err) {}
        return '';
    },
    setCookie(cname, cvalue, exdays) {
        try {
            let expires = '';
            if (typeof exdays !== 'undefined' && exdays !== null) {
                const d = new Date();
                d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
                expires = ';expires=' + d.toUTCString();
            }
            document.cookie = `${cname}=${cvalue};path=/${expires}`;
        } catch (err) {}
    },
    removeCookie(cname) {
        document.cookie = `${cname}=;path=/;expires=${new Date(
            -1
        ).toUTCString()}`;
    },
    getStorageItem(storage, key) {
        try {
            const value = window[storage].getItem(key);
            return value;
        } catch (err) {
            return '';
        }
    },
    getStorageItemExpires(key) {
        try {
            const item = window.localStorage.getItem(key);
            const { value, expires } = JSON.parse(item);
            if (expires > Date.now()) {
                return value;
            } else {
                return '';
            }
        } catch (err) {
            return '';
        }
    },
    setStorageItemExpires(key, value, days = 1) {
        let item = JSON.stringify({
            value,
            expires: Date.now() + days * 86400000
        });
        try {
            window.localStorage.setItem(key, item);
        } catch (err) {}
    },
    setStorageItem(storage, key, value) {
        try {
            window[storage].setItem(key, value);
        } catch (err) {}
    },
    colorToRgba(sHex, alpha = 1) {
        // 十六进制颜色值的正则表达式
        const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
        /* 16进制颜色转为RGB格式 */
        let sColor = sHex.toLowerCase();
        if (sColor && reg.test(sColor)) {
            if (sColor.length === 4) {
                let sColorNew = '#';
                for (let i = 1; i < 4; i += 1) {
                    sColorNew += sColor
                        .slice(i, i + 1)
                        .concat(sColor.slice(i, i + 1));
                }
                sColor = sColorNew;
            }
            //  处理六位的颜色值
            const sColorChange = [];
            for (let i = 1; i < 7; i += 2) {
                sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)));
            }
            return 'rgba(' + sColorChange.join(',') + ',' + alpha + ')';
        } else if (sColor.indexOf('rgb(') !== -1) {
            return sColor
                .replace('rgb', 'rgba')
                .replace(')', ',' + alpha + ')');
        } else if (sColor.indexOf('rgba') !== -1) {
            return sColor.replace(/,[^,]+\)$/, ',' + alpha + ')');
        } else {
            return '';
        }
    },
    debounce(fn, delay = 200) {
        let timer;
        return function () {
            let context = this;
            let args = arguments;

            clearTimeout(timer);
            timer = setTimeout(function () {
                fn.apply(context, args);
            }, delay);
        };
    },
    throttle(fn, delay) {
        let last;
        let timer;

        delay || (delay = 250);

        return function () {
            let context = this;
            let args = arguments;
            let now = +new Date();
            if (last && now < last + delay) {
                clearTimeout(timer);
                timer = setTimeout(function () {
                    last = now;
                    fn.apply(context, args);
                }, delay);
            } else {
                last = now;
                fn.apply(context, args);
            }
        };
    },
    // 防止按钮多次点击的触发
    debounceAsync(fn) {
        let loading = false;
        return async function () {
            if (loading) {
                return;
            }
            loading = true;
            try {
                return await fn.apply(this, arguments);
            } finally {
                loading = false;
            }
        };
    },
    // 单例的定时器
    singleSetTimeOut(fn, time = 500) {
        let timer;
        return function () {
            if (timer) {
                return;
            }
            timer = setTimeout(fn.bind(this), time);
        };
    },

    // 获取异步加载的 dom
    /**
     *
     * @param {*}  selector  获取的 选择器
     *             doc       默认为 document
     *             all       是使用 querySelectorAll
     *             time      300         每 300 尝试获取一次
     *             max       2000        300 * 2000 / 1000 / 60   默认 10 分钟，否则超时
     */
    async getAsyncDom(params) {
        let {
            selector,
            doc = document,
            all = false,
            time = 300,
            max = 2000
        } = params;
        if (max <= 0) {
            return Promise.reject(`getAsyncDom  exceed max times: ${selector}`);
        }
        if (all) {
            let dom = doc.querySelectorAll(selector);
            if (dom.length > 0) {
                return dom;
            }
        } else {
            let dom = doc.querySelector(selector);
            if (dom) {
                return dom;
            }
        }

        await this.sleep(time);
        return this.getAsyncDom({ ...params, max: max - 1 });
    },
    async sleep(time = 500) {
        return new Promise(resolve => {
            setTimeout(resolve, time);
        });
    },
    /**
     * 获取对象的某个属性值，没有则返回默认值
     * @param {Object} obj 被解析的对象
     * @param {string} path 要找的某个key的路径
     * @param {Any} def 找不到返回的默认值
     */
    getValueByPath(obj, path, def) {
        path = path || '';
        const paths = path.split('.');
        let current = obj;
        let result;
        for (let i = 0, j = paths.length; i < j; i++) {
            const key = paths[i];
            if (!current) break;

            if (i === j - 1) {
                result = current[key];
                break;
            }
            current = current[key];
        }
        return isUndef(result) ? def : result;
    },
    // 获取 js 脚本
    getScriptContent(code) {
        let result = code.match(GET_SCRIPT_CONTENT);
        console.log(result);
    }
};
